module.exports = __webpack_public_path__ + "img/case-2.76e5c2f.png";